import { useUserValidations } from '~/composables/useUserValidations';

export default function (): boolean {
  const { $debug } = useNuxtApp();

  try {
    const { isEmailVerified, isSmsVerified } = useUserValidations();

    const checkContactRules = computed(() => {
      return isEmailVerified.value || isSmsVerified.value;
    });

    if ($debug.isEnabled) {
      console.groupCollapsed('🗺️ ~ CONTACT VALIDATION:\n');
      console.log('email verified:', isEmailVerified.value);
      console.log('sms verified:', isSmsVerified.value);
      console.log('validated:', checkContactRules.value);
      console.groupEnd();
    }

    return checkContactRules.value;
  } catch (err) {
    if ($debug.isEnabled) {
      console.groupCollapsed('🗺️ ~ CONTACT VALIDATION:\n');
      console.error(err);
      console.groupEnd();
    }

    return false;
  }
}
